import { IconButton } from '@mui/material';
import CONFIG from '../../../config';
import React from 'react';
import WidgetCheckbox from '../../../components/widgets/WidgetCheckbox';
import DownloadIcon from '@mui/icons-material/Download';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WidgetInputText from '../../../components/widgets/WidgetInputText';
import DocumentState from '../../client/dossier/DocumentState';
import axios from "axios";
import FicheDocuments from './FicheDocuments';


function FicheGroupDocuments({ user, setUser, groupIcon, groupName, documentList, uploadable = false }) {
  const getDocument = (user, type_dossier, document_name) => {
    var document = null;
    
    if (type_dossier == 'deuxieme_locataire') {
      document = user.dossier.deuxieme_locataire.documents[document_name];
    } else if (type_dossier == 'dossier') {
      document = user.dossier.documents[document_name];
    } else {
      document = user.dossier.list_garants[type_dossier].documents[document_name];
    }

    return document
  };

  return (
    <>
      <div className='divide-y divide-gray-300 grid grid-cols-12 gap-x-4 m-6 mt-0 py-2 px-6 bg-white my-shadow'>
        <div className='flex col-span-12 w-full text-center justify-between py-4'>
          <div className='flex col-span-8 w-full items-end'>
            <div className='pr-2 text-ame-gray'>
              {groupIcon}
            </div>
            <div>
              <h2>{groupName}</h2>
            </div>
          </div>
        </div>

        {documentList.sort(function (a, b) {
          var x = getDocument(user, a.type_dossier, a.document_name).obligatoire_cond || getDocument(user, a.type_dossier, a.document_name).obligatoire_admin;
          var y = getDocument(user, b.type_dossier, b.document_name).obligatoire_cond || getDocument(user, b.type_dossier, b.document_name).obligatoire_admin;
          return ((x > y) ? -1 : ((x < y) ? 1 : 0));
        }).map(document => <FicheDocuments key={document.titre} user={user} setUser={setUser} title={document.titre} type_dossier={document.type_dossier} document_name={document.document_name} doc={getDocument(user, document.type_dossier, document.document_name)} uploadable={uploadable} ></FicheDocuments>)}
      </div>
    </>
  );
}

export default FicheGroupDocuments;